import { Complexity } from '../../types';
import styles from './ComplexityIndicator.module.css';

const complexityColor: Record<Complexity, string> = {
  low: '#7a8716',
  medium: '#d4691c',
  high: '#e0472c',
};

const complexityLabel: Record<Complexity, string> = {
  low: 'Low complexity',
  medium: 'Medium complexity',
  high: 'High complexity',
};

const filledDots: Record<Complexity, number> = {
  low: 1,
  medium: 2,
  high: 3,
};

interface ComplexityIndicatorProps {
  complexity: Complexity;
}

export function ComplexityIndicator({ complexity }: ComplexityIndicatorProps) {
  const color = complexityColor[complexity];
  const filled = filledDots[complexity];

  return (
    <div className={styles.indicator}>
      <div className={styles.dots}>
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            className={styles.dot}
            style={i < filled ? { background: color } : { background: 'transparent', borderColor: color }}
          />
        ))}
      </div>
      <span className={styles.label} style={{ color }}>
        {complexityLabel[complexity]}
      </span>
    </div>
  );
}
